import {useMutation} from '@tanstack/react-query';

import {RQ_UPDATE_Admin_PROFILE_API, RQ_UPDATE_User_PROFILE_API} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQUpdateAdminProfileAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_update_profile'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_UPDATE_Admin_PROFILE_API.url.replace('<%= id %>', id);
      return rqCreateRequest(
        {...RQ_UPDATE_Admin_PROFILE_API, url},
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};

export const RQUpdateUserProfileAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_update_profile'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_UPDATE_User_PROFILE_API.url.replace('<%= id %>', id);
      return rqCreateRequest(
        {...RQ_UPDATE_User_PROFILE_API, url},
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};
